export default __webpack_public_path__ + "static/getindata-big-data-consultants-clutch-926bf1292033eb3b3ad94ed9f3a2dc17.png";